
import SimilarProducts from '@/graphql/queries/products/SimilarProducts'

export default {
  props: {
    product: {
      type: Object,
      default: null
    }
  },
  vessel: {
    title: {
      fontSize: '2xl',
      textColor: 'black',
      lg: {
        fontSize: '3xl'
      }
    }
  },
  watch: {
    product: '$fetch'
  },
  async fetch() {
    if (!this.product) return

    if (this.product.related && this.product.related.length) {
      return this.products = this.product.related
    }

    const { data } = await this.$graphql.query({
      clientId: 'eshop',
      query: SimilarProducts,
      variables: {
        where: { id: this.product.id },
        first: 8,
        fields: ['categories']
      }
    })

    this.products = data.similar
  },
  data() {
    return {
      products: []
    }
  },
  computed: {
    buttonAttrs() {
      return {
        color: 'black',
        fontSize: 'md',
        padding: 'sm'
      }
    }
  }
}
